import React from 'react';
import { Funnel } from '@ant-design/plots';
import Lang from "@/components/Lang/Lang";

const DemoFunnel = (props={}) => {
    const getList=(list=[])=>{
        list.forEach((item,i)=>{
            item.pv =  item.buyerNum//(6-i) *10
        });
        return list;
    }
    const data = getList(props.funnelList);
    //     ||[
    //     { newBuyerLabelTypeName: '待初步联系客户', pv: 60,buyerNum:20 },
    //     { newBuyerLabelTypeName: '选品', pv: 50,buyerNum:20, stopAvgDays:3 },
    //     { newBuyerLabelTypeName: '下单', pv: 40,buyerNum:20, stopAvgDays:3 },
    //     { newBuyerLabelTypeName: '成交实现', pv: 30,buyerNum:20, stopAvgDays:3 },
    // ];
    const colors = [
        '#F96116',
        '#2A7DD9',
        '#612BDB',
        '#C91313',
    ];
    const config = {
        data,
        scale: {
            color: { range: colors },
            },
        xField: 'newBuyerLabelTypeName',
        paddingRight:400,
        yField: 'pv',
        height:350,
        // shapeField: 'pyramid',
        style: {
            stroke: '#fff',
            strokeWidth: 0.04,
        },
        legend:{
            // label: false
        },
        label: [
            {
                text: (d) => `${d.buyerNum}`,
                position: 'inside',
                fontSize: 14,
            },
            {
                render: ($, data, i) => {
                    if(data.buyerNum>0){
                        return (
                            <div
                                style={{
                                    height: 1,
                                    width: 400,
                                    margin: '30px 0',
                                    borderBottom: "2px dotted #D9D9D9",
                                }}
                            ></div>
                        );
                    }else return ""
                },
                position: 'top-right',
                textBaseline: 'hanging',
                dx: (item,i) => i* 40,
            },
            {
                text: (d, i, data) => {
                    if(d.buyerNum>0){
                        if (i) {
                            const iPrevPv = data[i - 1].buyerNum || 0;
                            const iConRate = iPrevPv > 0 ? ((d.buyerNum / iPrevPv) * 100).toFixed(2) : 0;
                            return ` ${d.newBuyerLabelTypeName}\n ${Lang({id:"ZhuanHuaLvPingJunTingLiuS",
                                default:`转化率 ${iConRate} %，平均停留时间 ${d.stopAvgDays}天`,
                                params:[iConRate,d.stopAvgDays]})}`;
                        }else return `\n ${d.newBuyerLabelTypeName}`;
                    }else return ""
                },
                position: 'top-right',
                textAlign: 'left',
                textBaseline: 'top',
                // textBaseline: 'hanging',
                dx: 30,
                dy: -2,
            },
        ],
    };

    return (<div style={{maxWidth:"700px",margin:"0 auto"}}>
        <Funnel {...config} />
    </div>);
};

export default DemoFunnel;